import { useRouter } from "next/router";
import { format, subDays } from "date-fns";
import { useEffect } from "react";
import { useDateInput } from "ui";
import { useAnalytics } from "../../analytics/analyticsProvider";
import type { Event } from "../../analytics/analyticsManager";

export function useInsightsViewAnalytics({ eventName }: { eventName: Event }) {
  const { analytics } = useAnalytics();

  const router = useRouter();
  useEffect(() => {
    const startDate = router.query.start_date;
    const endDate = router.query.end_date;
    if (!startDate || !endDate) return;

    const now = new Date();
    const today = format(now, useDateInput.valueFormatString);
    const lastWeek = format(subDays(now, 7), useDateInput.valueFormatString);
    const last30Days = format(subDays(now, 30), useDateInput.valueFormatString);

    const isTodaySelected = startDate === today && endDate === today;
    const isLastWeekSelected = startDate === lastWeek && endDate === today;
    const isLast30DaysSelected = startDate === last30Days && endDate === today;

    const preset = isTodaySelected
      ? "today"
      : isLastWeekSelected
        ? "last_week"
        : isLast30DaysSelected
          ? "last_30_days"
          : "custom";

    analytics.track(eventName, {
      preset,
    });
  }, [eventName, router.query.start_date, router.query.end_date, analytics]);
}
